export type OriginContext = {
  product: OriginContextProduct;
  tool: string;
  viewerUrl?: string;
  fallbackViewerUrl?: string;
};

export type OriginContextPayload = {
  product: OriginContextProduct;
  tool: string;
  metadata?: Record<string, string>;
};

export enum OriginContextProduct {
  Build = "build",
  Cost = "cost",
  DesignCollaboration = "dc",
  Docs = "docs",
  Insight = "insight",
  ModelCoordination = "model",
  Takeoff = "takeoff",
  Navisworks = "navisworks",
  Revit = "revit",
  AutoCAD = "autocad",
}
